import type { IdentitySchema, IdentityField, IdentityTemplate } from '@webforge-survey/shared';

/**
 * Templates d'identitySchema partagés entre la création/édition (créateur) et
 * l'écran répondant. Source unique de vérité pour les champs par défaut.
 */
export const TEMPLATE_SCHEMAS: Record<Exclude<IdentityTemplate, 'custom'>, IdentityField[]> = {
  minimal: [
    { name: 'prenom', label: 'Prénom', type: 'text', required: true },
    { name: 'email', label: 'Adresse e-mail', type: 'email', required: true },
  ],
  email: [{ name: 'email', label: 'Adresse e-mail', type: 'email', required: true }],
  extended: [
    { name: 'prenom', label: 'Prénom', type: 'text', required: true },
    { name: 'nom', label: 'Nom', type: 'text', required: false },
    { name: 'email', label: 'Adresse e-mail', type: 'email', required: true },
    { name: 'organisation', label: 'Organisation', type: 'text', required: false },
  ],
};

export const TEMPLATE_LABELS: Record<IdentityTemplate, string> = {
  minimal: 'Minimal (prénom + e-mail)',
  email: 'E-mail seul',
  extended: 'Étendu (prénom, nom, e-mail, organisation)',
  custom: 'Personnalisé',
};

export const TEMPLATE_DESCRIPTIONS: Record<IdentityTemplate, string> = {
  minimal: 'Le minimum pour recontacter : prénom et adresse e-mail.',
  email: 'Uniquement l\'adresse e-mail.',
  extended: 'Identité complète pour un suivi nominatif.',
  custom: 'Définissez vos propres champs ci-dessous.',
};

/** Schéma résolu (avec ses champs) pour un template donné. */
export function schemaForTemplate(
  template: IdentityTemplate,
  customFields: IdentityField[] = [],
): IdentitySchema {
  if (template === 'custom') {
    return { template: 'custom', fields: customFields };
  }
  return { template, fields: TEMPLATE_SCHEMAS[template] };
}

/** Champs effectifs d'un schéma (résout le template si fields absents). */
export function fieldsOf(schema: IdentitySchema | null | undefined): IdentityField[] {
  if (!schema) return [];
  if (schema.fields && schema.fields.length > 0) return schema.fields;
  if (schema.template !== 'custom') return TEMPLATE_SCHEMAS[schema.template] ?? [];
  return [];
}
